import { useContext } from 'react';
import { MainRootStore, StoreContext } from '../store';

export const useStores = () => useContext<MainRootStore>(StoreContext);
